import { useQuery } from "@tanstack/react-query";

import { VimeoOEmbedResponse, getVimeoOEmbed } from "services";

import { DEFAULT_CACHE_TIME } from "consts";

const formatVideoDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (secs === 0) {
    return `${mins} min`;
  }
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const useGetVimeoData = (vimeoId: string, isFullUrl: boolean = false) => {
  const { data, isLoading, isError } = useQuery<VimeoOEmbedResponse>({
    queryKey: ["vimeoOEmbed", vimeoId, isFullUrl],
    queryFn: ({ signal }) => getVimeoOEmbed({ vimeoId, signal, isFullUrl }),
    enabled: !!vimeoId,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });

  return {
    thumbnailUrl: data?.thumbnail_url ?? null,
    title: data?.title ?? null,
    duration: data?.duration ?? null,
    formattedDuration: data?.duration ? formatVideoDuration(data.duration) : null,
    isLoading,
    isError,
  };
};
